import { render } from "./MsisdnDetailsPopup.vue?vue&type=template&id=7f2c1056&scoped=true"
import script from "./MsisdnDetailsPopup.vue?vue&type=script&lang=js"
export * from "./MsisdnDetailsPopup.vue?vue&type=script&lang=js"

import "./MsisdnDetailsPopup.vue?vue&type=style&index=0&id=7f2c1056&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f2c1056"]])

export default __exports__